import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { MdChevronRight } from 'react-icons/md';

import { Box, Flex, Text, useTheme } from '@chakra-ui/react';
import { Headline } from '@ldp-web/component-library/ui/molecules/headline';
import { Modal } from '@ldp-web/component-library/ui/molecules/modal';
import { Paragraph } from '@ldp-web/component-library/ui/atoms/paragraph';
import ActionButton from '../action-button';

import { IBrand } from '../beauty-brands/beauty-brands.interface';

import { capitalizeEveryFirstLetter } from '@/utils';
import styles from './brands-list.module.scss';

const BrandsList: FC<{ data: IBrand[] }> = ({ data }) => {
  const { common } = useTheme();
  const { formatMessage } = useIntl();
  const [brands, setBrands] = useState<IBrand[]>([]);
  const [isAllBrandsModalOpen, setIsAllBrandsModalOpen] = useState(false);

  useEffect(() => {
    const sortedBrands = data?.sort((a: IBrand, b: IBrand) => a.name.localeCompare(b.name)) || [];
    setBrands(sortedBrands);
  }, [data]);

  const FormattedList: FC<{ sliceAt: number }> = ({ sliceAt }) => {
    return (
      <>
        {brands.slice(0, sliceAt).map((brand: IBrand) => (
          <Text key={brand.name} data-testid="subHeading" {...common?.common02Regular} className={styles.brandItem}>
            {capitalizeEveryFirstLetter(brand.name)}
          </Text>
        ))}
      </>
    );
  };

  return (
    <Box>
      <Flex justifyContent="space-between">
        <Headline
          title={formatMessage({ id: 'beautyBrandsHeader' })}
          data-testid="beauty-brands-headline"
          headlineSize={3}
        />
        <ActionButton
          rightIcon
          handleClick={() => setIsAllBrandsModalOpen(true)}
          icon={MdChevronRight}
          linkText={formatMessage({ id: 'beautyBrandsCTAText' })}
          textDecoration="underline"
        />
      </Flex>
      <Paragraph alignment="left" size={2}>
        {formatMessage({ id: 'beautyBrandsParagraph' })}
      </Paragraph>
      <div className={styles.brands}>
        <div className={styles.brandsContainer}>
          <FormattedList sliceAt={36} />
        </div>
      </div>
      {isAllBrandsModalOpen ? (
        <Modal
          isOpen={isAllBrandsModalOpen}
          onClose={() => setIsAllBrandsModalOpen(false)}
          callToAction1={{
            text: formatMessage({ id: 'deleteAddressSecondaryButton' }),
            url: '',
          }}
          modalTitle={formatMessage({ id: 'beautyBrandsModalTitle' })}
        >
          <div className={styles.allBrandsModal}>
            <FormattedList sliceAt={brands.length} />
          </div>
        </Modal>
      ) : null}
    </Box>
  );
};

export default BrandsList;
